import React from "react";

import destination_1 from "../../public/wheretogo-krkonose/snezka/destination_1.png";
import destination_2 from "../../public/wheretogo-krkonose/snezka/destination_2.png";
import destination_3 from "../../public/wheretogo-krkonose/snezka/destination_3.png";
import destination_4 from "../../public/wheretogo-krkonose/snezka/destination_4.png";
import destination_5 from "../../public/wheretogo-krkonose/snezka/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-krkonose/snezka/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-krkonose/snezka/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-krkonose/snezka/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-krkonose/snezka/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const Snezka = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Sněžka</h1>
            <p>
              Nachází se ve východní části Krkonoš na Hraničním hřebenu. Přes
              její vrchol prochází česko-polská státní hranice. Na severní
              polské straně spadají srázy do údolí Lomničky, na jižní české do
              Obřího dolu. Západní svahy se snižují do Úpské rašeliny a východní
              klesají v Obří hřbet. Skalnatý holý vrchol se rozkládá na 30
              akrech. Díky své výšce poskytuje neomezený panoramatický výhled do
              daleké krajiny České republiky a Polska.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>lanovka</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>restaurace</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>1603 m. n. m.</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>turistické trasy</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Název Sněžka pochází z 19. století, je odvozen od pojmenování
                  Sněžná – jako "sněhem pokrytá". První český název byl Pahrbek
                  Sněžný, pak Sněžovka, od roku 1823 pak definitivně Sněžka.
                </li>
                <li>
                  Na vrcholu byla postavena rotundová kaple sv. Vavřinče, která
                  je nejstarším objektem na vrcholu Sněžky.
                </li>
                <li>
                  Raritou je Česká poštovna, která je nejvýše položenou
                  poštovnou v České republice – můžete odtud poslat poštu s
                  razítkem Poštovna na Sněžce.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Snezka;
